module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tpro",
    attrs: {
      "id": "TPro"
    }
  }, [_c('PinchInImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-text flexcenter",
    style: (_vm.toparea_visible),
    attrs: {
      "id": "toparea"
    }
  }, [(_vm.isEnvironmentPc()) ? [_c('textarea', {
    staticClass: "input item font24 cancelEnter",
    staticStyle: {
      "color": "#000000",
      "overflow": "hidden"
    },
    attrs: {
      "readOnly": "",
      "id": "inputtext",
      "placeholder": "英文を入力してください"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-ok",
    attrs: {
      "id": "okbutton"
    },
    on: {
      "click": _vm.setAnswer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-skip",
    attrs: {
      "id": "ssbutton"
    },
    on: {
      "click": _vm.skipQuestion
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font24 answer",
    attrs: {
      "id": "answer_string"
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.isEnvironmentPc()) ? [_c('div', {
    staticClass: "cards-container active-type2 card-voice"
  }, [_vm._l((_vm.acts), function(actblock, index) {
    return [_c('div', {
      key: index,
      class: actblock[0].layoutClass
    }, [_vm._l((actblock), function(act, index2) {
      return [_c('div', {
        key: index2,
        class: act.active,
        attrs: {
          "id": act.active_id,
          "name": act.sound
        }
      }, [_c('p', {
        attrs: {
          "id": act.text_id
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getText(act))
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "image"
      }, [_c('img', {
        attrs: {
          "src": act.image
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "icon-voice",
        style: (act.sbutton_visible),
        attrs: {
          "id": act.sbutton_id
        }
      }), _vm._v(" "), _c('div', {
        attrs: {
          "id": act.correct_id
        }
      })])])]
    })], 2)]
  })], 2)] : [_c('div', {
    staticClass: "cards-container swiper-container swiper-container1 active-type2 card-voice"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l((_vm.acts), function(actblock, index) {
    return [_c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('div', {
      class: actblock[0].layoutClass
    }, [_c('div', {
      staticClass: "swiper-container swiper-container2"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, [_vm._l((actblock), function(act, index2) {
      return [_c('div', {
        key: index2,
        class: act.active,
        attrs: {
          "id": act.active_id,
          "name": act.sound
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.currentActIndex == _vm.getTargetActTypeTyping(index, index2) && _vm.isShowTextArea(_vm.pathstep.acts[_vm.currentActIndex])),
          expression: "currentActIndex == getTargetActTypeTyping(index, index2) && isShowTextArea(pathstep.acts[currentActIndex])"
        }],
        staticClass: "textarea-wrap",
        style: (_vm.placeholderStyles)
      }, [_c('textarea', {
        staticClass: "cancelEnter",
        attrs: {
          "id": act.inputtext_id,
          "placeholder": "英文を入力してください"
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "answer",
        staticStyle: {
          "visibility": "hidden"
        },
        attrs: {
          "id": act.answer_string_id
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "icon-wrap"
      }, [_c('div', {
        staticClass: "icon-ok",
        attrs: {
          "id": act.okbutton_id
        },
        on: {
          "click": _vm.setAnswer
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "icon-skip",
        attrs: {
          "id": act.ssbutton_id
        },
        on: {
          "click": _vm.skipQuestion
        }
      })])]), _vm._v(" "), _c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.currentActIndex != _vm.getTargetActTypeTyping(index, index2) || !_vm.isShowTextArea(_vm.pathstep.acts[_vm.currentActIndex])),
          expression: "currentActIndex != getTargetActTypeTyping(index, index2) || !isShowTextArea(pathstep.acts[currentActIndex])"
        }],
        attrs: {
          "id": act.text_id
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getText(act))
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "image",
        on: {
          "touchstart": function($event) {
            return _vm.onTouchStart(act.image)
          },
          "touchend": function($event) {
            return _vm.onTouchEnd()
          },
          "touchmove": function($event) {
            return _vm.onTouchEnd()
          }
        }
      }, [_c('img', {
        attrs: {
          "src": act.image
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "icon-voice",
        style: (act.sbutton_visible),
        attrs: {
          "id": act.sbutton_id
        }
      }), _vm._v(" "), _c('div', {
        attrs: {
          "id": act.correct_id
        }
      })])])]
    })], 2)])])])]
  })], 2)])]], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ce2437c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-3ce2437c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/TPro.vue
// module id = 618
// module chunks = 1